// src/utils/utils.js

/**
 * 格式化日期为 YYYY-MM-DD 格式
 * @param {Date} date - 要格式化的日期对象
 * @returns {string} 格式化后的日期字符串
 */
export function formatDate(date) {
    if (!date) return '';
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
}

/**
 * 检查是否为手机号码
 * @param {string} phone - 待检查的电话号码
 * @returns {boolean} 是否为有效的手机号码
 */
export function isPhoneNumber(phone) {
    const reg = /^1[3456789]\d{9}$/;
    return reg.test(phone);
}

/**
 * 分割数字千氛位 加逗号
 * @param {string} value - 要分隔的数字
 */
// export function numberToCurrencyNo(value) {
//     if (!value) return 0
//     // 获取整数部分
//     const intPart = Math.trunc(value)
//     // 整数部分处理，增加,
//     const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
//     // 预定义小数部分
//     let floatPart = ''
//     // 将数值截取为小数部分和整数部分
//     const valueArray = value.toString().split('.')
//     if (valueArray.length === 2) { // 有小数部分
//         floatPart = valueArray[1].toString() // 取得小数部分
//         return intPartFormat + '.' + floatPart
//     }
//     return intPartFormat + floatPart
// }


export const numberToCurrencyNo = (value) =>  {
    if (!value) return 0
    // 获取整数部分
    const intPart = Math.trunc(value)
    // 整数部分处理，增加,
    const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // 预定义小数部分
    let floatPart = ''
    // 将数值截取为小数部分和整数部分
    const valueArray = value.toString().split('.')
    if (valueArray.length === 2) { // 有小数部分
        floatPart = valueArray[1].toString() // 取得小数部分
        return intPartFormat + '.' + floatPart
    }
    return intPartFormat + floatPart
}

export const formatTimestamp = (ts) => {
    const date = new Date(ts);
    const Y = date.getFullYear();
    const M = String(date.getMonth() + 1).padStart(2, '0');
    const D = String(date.getDate()).padStart(2, '0');
    const h = String(date.getHours()).padStart(2, '0');
    const m = String(date.getMinutes()).padStart(2, '0');
    const s = String(date.getSeconds()).padStart(2, '0');
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}
